module.exports = __webpack_public_path__ + "static/media/LogoLoading.65122e1a.svg";